export function formatYYYYMMDDLocal(tz?: string, d?: Date): string {
  const date = d ?? new Date();
  try {
    if (tz) {
      const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
      // en-CA yields yyyy-mm-dd; ensure we normalize the separator
      return fmt.format(date);
    }
  } catch {}
  // Fallback: local components
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d2 = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d2}`;
}

export function addDaysYYYYMMDD(base: string, days: number, tz?: string): string {
  // Parse yyyy-mm-dd into a Date in local time
  const [y, m, d] = base.split('-').map(Number);
  const date = new Date(y, (m || 1) - 1, d || 1);
  date.setDate(date.getDate() + (Number.isFinite(days) ? days : 0));
  return formatYYYYMMDDLocal(tz, date);
} 

// Render a date-only ISO (e.g., 'YYYY-MM-DD' or 'YYYY-MM-DDT00:00:00.000Z') without timezone shift.
// Uses UTC to avoid -1 day in negative timezones when the server sends midnight UTC.
export function formatDateOnlyUTC(iso: string | Date | null | undefined): string {
  if (!iso) return '';
  try {
    const d = new Date(iso as any);
    if (Number.isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString(undefined, { timeZone: 'UTC' });
  } catch {
    return String(iso ?? '');
  }
}